import React from 'react';

const Background = () => {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none">
      <div className="absolute inset-0 bg-background-light dark:bg-background-dark transition-colors duration-500" />
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/8 via-transparent to-slate-900/5 dark:from-cyan-400/10 dark:to-slate-950/40" />
      <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-cyan-400/15 dark:bg-cyan-500/20 rounded-full blur-[100px] animate-pulse-slow" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[600px] h-[600px] bg-slate-400/10 dark:bg-cyan-900/25 rounded-full blur-[120px]" />
    </div>
  );
};

export default Background;
